export default __webpack_public_path__ + "static/media/bg-ring-3.df18d8e0.png";